export default {"src":"/_next/static/media/ico_del.b4e18280.svg","height":26,"width":20,"blurWidth":0,"blurHeight":0};